module.exports = __webpack_public_path__ + "img/sensitivity-icon-2.88d38370.svg";